import './Navbar.css'
import * as React from "react";
import {Link, Navigate} from 'react-router-dom'

function Navbar() {
  return (
    <div class="navbar">
      <Link to='/' class='tab'>Home</Link>
      <Link to='/About' class='tab'>About</Link>
      <Link to='/Experience' class='tab'>Experience</Link>
      <Link to='/Projects' class='tab'>Projects</Link>
    </div>
    
  );
}
export default Navbar;
